import { render, staticRenderFns } from "./ToDoInboxLeftSidebar.vue?vue&type=template&id=f946f65e"
import script from "./ToDoInboxLeftSidebar.vue?vue&type=script&lang=js"
export * from "./ToDoInboxLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports